import request from '@/utils/request'
import axios from 'axios'
import downLoadRequest from '@/utils/downLoadRequest'

export function fetchList(params) {
  return request({
    url:'/calibrationInfo/list',
    method:'get',
    params:params
  })
}

export function tableColumns(){
  return request({
    url: '/calibrationInfo/tableColumns',
    method: 'get'
  })
}


export function exportExcels(params){
  downLoadRequest({
    url: '/calibrationInfo/download',
    method: 'get',
    params:params
  })
}

export function sendTodo(params){
  return request({
    url: '/calibrationInfo/sendTodo',
    method: 'post',
    params:params
  })
}

export function submit(params){
  return request({
    url: '/calibrationInfo/submit',
    method: 'post',
    data:params
  })
}

export function updateExcelVerion(){
  return request({
    url: '/calibrationInfo/updateExcelVerion',
    method: 'post',
  })
}

export function deleteAll() {
  return request({
    url: '/calibrationInfo/delete',
    method: 'post',
  })
}

export function findBatch(){
  return request({
    url: '/calibrationInfo/findBatch',
    method: 'get',
  })
}

export function findAppraiserList(){
  return request({
    url: '/calibrationInfo/findAppraiserList',
    method: 'get',
  })
}

export function findAssessDateListByStatus(){
  return request({
    url: '/calibrationInfo/findAssessDateListByStatus',
    method: 'get',
  })
}

export function findStateFlagList(){
  return request({
    url: '/sysDict/listAll',
    method: 'get',
    params: {type:"state_flag"}
  })
}

export function createAssess(params){
  return request({
    url: '/calibrationInfo/createAssess',
    method: 'post',
    params:params
  })
}

export function getUserRole(){
  return request({
    url: '/calibrationInfo/findUserRole',
    method: 'get',
  })
}

export function getHomePageHint(){
  return request({
    url: '/calibrationInfo/findHomePageHint',
    method: 'get',
  })
}

export function checkFileCopyNum(params){
  return request({
    url: '/calibrationInfo/checkFileCopyNum',
    method: 'get',
    params:params
  })
}

export function getFileCopyNum(params){
  return request({
    url: '/calibrationInfo/findFileCopyNum',
    method: 'get',
    params:params
  })
}

export function checkIsUploadCalculateFile(params){
  return request({
    url: '/calibrationInfo/checkIsUploadCalculateFile',
    method: 'get',
    params:params
  })
}

export function checkUploadProgress(params){
  return request({
    url: '/calibrationInfo/checkUploadProgress',
    method: 'get',
    params:params
  })
}

export function delUploadCache(){
  return request({
    url: '/calibrationInfo/delUploadCache',
    method: 'get',
  })
}

export function getExcelVersionUpdateInfo(){
  return request({
    url: '/calibrationInfo/findExcelVersionUpdateInfo',
    method: 'get',
  })
}

export function getUserInfo(){
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function toBackLand(data){
  return request({
    url: '/paraContrast/toBackLand',
    method: 'post',
    data
  })
}

export function batchReplaceValue(data){
  return request({
    url: '/calibrationInfo/batchReplaceValue',
    method: 'post',
    data
  })
}

export function findPriceRecordList(params){
  return request({
    url: '/priceRecord/findPriceRecordList',
    method: 'get',
    params:params
  })
}

export function findPriceTableColumns(){
  return request({
    url: '/priceRecord/findPriceTableColumns',
    method: 'get'
  })
}

export function findBatchReplaceLogList(){
  return request({
    url: '/batchReplaceLog/list',
    method: 'get'
  })
}

export function loadAssessInfo() {
  return request({
    url:'/standardLand/loadAssessInfo',
    method:'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/calibrationInfo.js